module.exports = __webpack_public_path__ + "static/img/hezuo09.eda877b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo09.jpg
// module id = EfOv
// module chunks = 1